import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12
  }
});
